import { z } from "zod";

export const sunProtectionFabricColorSchema = z.object({
    id: z.string().nullish(),
    hexColor: z.string().nullish(),
    name: z.string().nullish(),
    price: z.number().nullish(),
    type: z.enum(["SUN_BLOCKING", "TRANSLUCENT"]).nullish(),
    image: z.object({ url: z.string().nullish() }).nullish(),
});

export const sunProtectionFrameColorSchema = z.object({
    id: z.string().nullish(),
    name: z.string().nullish(),
    hexColor: z.string().nullish(),
    price: z.number().nullish(),
});

export const sunProtectionColorCombinationSchema = z.object({
    id: z.string().nullish(),
    frameColorName: z.string().nullish(),
    fabricColorName: z.string().nullish(),
    irrelevant: z.boolean().nullish(),
    image: z
        .object({
            url: z.string().nullish(),
            alt: z.string().nullish(),
        })
        .nullish(),
});

export const sunProtectionSchema = z.object({
    id: z.string(),
    name: z.string(),
    subtitle: z.string().nullish(),
    hasFrameColor: z.boolean().nullish(),
    image: z.object({ url: z.string().nullish() }).nullish(),
    fabricColors: z.array(sunProtectionFabricColorSchema).nullish(),
    frameColors: z.array(sunProtectionFrameColorSchema).nullish(),
    colorCombinations: z.array(sunProtectionColorCombinationSchema).nullish(),
});

export const sunProtectionsResponseSchema = z.object({
    SunProtections: z.object({
        docs: z.array(sunProtectionSchema),
    }),
});
